<template>
    <div class="specialWarehousing-warp">
        <div class="title-wrap">
            <p @click="goBack"><icon name="to-left"></icon></p>
            <div class="title">特殊入仓地址查询</div>
        </div>
        <div class="content-wrap">
            <div :class="['input-wrap', addressSelectCommon.areaNameCommon ? 'hasValueClass' : '']">
                <div class="input">
                    <img src="~@/assets/images/ico/ico-home.png" />
                    <div v-if="addressSelectCommon.areaNameCommon">
                        <div @click.prevent="toggleSelector">
                            <div class="inputValue">
                                {{ addressSelectCommon.areaNameCommon }}
                            </div>
                            <div class="corner"></div>
                        </div>
                        <input v-model="address" class="tip" type="text" placeholder="可以输入关键词查询（选填）" />
                    </div>
                    <span v-else @click.prevent="toggleSelector">请选择省市区</span>
                </div>
                <div v-if="addressSelectCommon.areaNameCommon" class="search" @click.prevent="queryWare">查询</div>
            </div>
            <div v-for="item in resultList" :key="item.address" class="result-wrap">
                <h3>{{ item.companyName || '-' }}</h3>
                <p class="address">{{ item.address || '-' }}</p>
                <div class="detail">
                    <p><img src="~@/assets/images/ico/ware-ico1.png" alt="仓库类型：" />仓库类型：{{ item.warehouseName || '-' }}</p>
                    <p><img src="~@/assets/images/ico/ware-ico2.png" alt="入仓服务费：" />入仓服务费：{{ item.storageCost || '-' }}元/票</p>
                    <p><img src="~@/assets/images/ico/ware-ico3.png" alt="第三方仓库收费：" />第三方仓库收费：{{ item.storageCharge || '-' }}元/票</p>
                </div>
            </div>
        </div>
        <!-- 城市选择 -->
        <overlay :isShow.sync="isShowSelector" :enableBtn="enableBtn" :cbValid="validSelector">
            <h3 class="head">请选择查询城市</h3>
            <ul class="rgn-tab">
                <li v-for="(item, idx) in regionTabs" :key="item.id" @touchstart.stop="toggleTab(idx)">
                    <div class="btn-tab" :class="{ active: regionTabIndex === idx }">
                        {{ item.name }}
                    </div>
                </li>
            </ul>
            <div class="search-form">
                <input
                    v-model="inputTxt"
                    type="text"
                    class="search"
                    :placeholder="placeholderTxt"
                    @input="inputChange"
                    @click="searchInputFocus"
                    @blur="searchInputBlur"
                />
                <i class="icon-search"></i>
                <i v-if="inputTxt" class="icon-close" @click.prevent="clear"></i>
            </div>
            <!-- <div v-if="regionTabIndex === 0">
                <h4 class="hotCity">热门城市</h4>
                <ul class="hotCityList">
                    <li v-for="i in hotCityList" :key="i" @click="handledHotCity(i)">{{ i }}</li>
                </ul>
            </div> -->

            <form @submit.prevent="submitSelect">
                <div v-if="!searchAddressList.length">
                    <div v-if="regionTabIndex === 0">
                        <area-inland
                            page="accept"
                            :area="area"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :updateSelect="updateSelect"
                        />
                    </div>
                    <div v-if="regionTabIndex === 1">
                        <area-hmt
                            page="accept"
                            :area="area"
                            :max-level="2"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                </div>
                <ul v-else class="search-address-region">
                    <li
                        v-for="(item, index) in searchAddressList"
                        :key="index"
                        :class="{ active: index === selectedItemIndex }"
                        @click="selectedSearchAddress(item, index)"
                        v-html="item.html"
                    ></li>
                </ul>
            </form>
            <slot slot="button" slot-scope="props">
                <div ref="btnConfirm" class="btn-confirm" :class="{ active: props.active }">
                    <span>确认</span>
                </div>
            </slot>
        </overlay>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import InlandCitySelector from '@/components/citySelector/area-inland'
import HMTCitySelector from '@/components/citySelector/area-hmt'
import Overlay from '@/components/citySelector/overlay/'
import ajax from '../../api/ajax'
import mixCitySelector from '@/components/citySelector/mixin'
import UIP from '@/util/uip.js'
import { getHighHtml } from '@/util/util.js'
export default {
    name: 'SpecialWarehousing',
    components: {
        'area-inland': InlandCitySelector,
        'area-hmt': HMTCitySelector,
        overlay: Overlay
    },

    mixins: [mixCitySelector],
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            regionTabs: [
                {
                    id: 'chinaArea',
                    name: '中国内地'
                },
                {
                    id: 'hmtArea',
                    name: '港澳台'
                }
            ],
            isShowSelector: false, // 是否显示城市选择框
            enableBtn: false, // 选择结束，激活按钮
            regionTabIndex: 0, // 范围选择项(大陆、港澳台、国际)
            addressSelectCommon: {
                areaNameCommon: '',
                detailAddressCommon: '',
                countryCode: '',
                rateCode: '',
                code: '',
                area: '',
                index: 0,
                cityCode: ''
            },
            areaName: '国家/地区选择', // 选择地址名
            intlProvinces: [], // 国际城市信息（包含港澳台）
            inputTxt: '', // 搜索框输入文案
            searchAddressList: [], // 搜索结果列表
            selectedItemIndex: -1, // 搜索结果选中索引
            area: {},
            resultList: [],
            hotCityList: ['深圳', '上海', '广州', '北京', '武汉', '杭州', '成都', '南京'],
            address: ''
        }
    },
    computed: {
        /**
         * 根据范围选择项动态匹配输入框默认文案
         */
        placeholderTxt() {
            return (
                new Map([
                    [0, '请输入省份/城市/市区搜索'],
                    [1, '请输入地区名进行搜索']
                ]).get(this.regionTabIndex) || '请输入地区名进行搜索'
            )
        },
        /**
         * 行政区的 regionKey
         */
        regionKey() {
            return (
                new Map([
                    [0, 'local_region_cn_sc'],
                    [1, 'local_region_hk_mo_tw_sc'],
                    [2, 'local_ibu_hotcounties_sc']
                ]).get(this.regionTabIndex) || 'local_region_cn_sc'
            )
        }
    },
    watch: {
        inputTxt(val) {
            if (!val) {
                this.clear()
            }
        },
        regionTabIndex(val) {
            if (this.inputTxt) {
                this.inputChange()
            }
        },
        isShowSelector(val) {
            // 重新打开窗口清空搜索记录
            if (val) {
                return (this.inputTxt = '')
            }
            this.selectedItemIndex = -1
        }
    },
    created() {
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
        this.setShowCustomer(true)
    },
    mounted() {
        window.addEventListener('resize', this.resizeHeight, false)
    },
    beforeDestroy() {
        // 销毁前解绑
        window.removeEventListener('resize', this.resizeHeight, false)
    },
    methods: {
        ...mapMutations('range', {
            setSelectorValid: 'setSelectorValid',
            setAreaData: 'setAreaData',
            setAreaDataDest: 'setAreaDataDest'
        }),
        ...mapMutations(['setShowCustomer']),
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        }),
        // 返回特殊入仓产品介绍页
        goBack() {
            this.$router.push({
                path: '/cn/sc/product/detail/IN102?noHead=true'
            })
        },
        /**
         * 页面resize响应的事件函数
         * **/
        resizeHeight() {
            const winScreenHeight = document.documentElement.clientHeight || document.body.clientHeight
            if (winScreenHeight > this.screenHeight) {
                // 键盘收起
                this.selectClass = ''
            }
            this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight
        },
        // 点击输入框时处理安卓 键盘挡住问题
        searchInputFocus() {
            const timerFocus = setTimeout(() => {
                timerFocus && clearTimeout(timerFocus)
                this.selectClass = 'select-rel'
                document.body.scrollTop = 0
                // 如果document.body.scrollTop始终为0，用document.documentElement.scrollTop代替
                document.documentElement.scrollTop = 0
                window.scrollTo && scrollTo(0, 0)
            }, 500)
        },
        /**
         * 选中某一项返回接口查询结果
         */
        selectedSearchAddress(item, index) {
            this.enableBtn = true
            const resultCounty = item.county ? `${item.county}` : ''
            this.updateAreaCode({
                code: item.countyCode || item.cityCode,
                areaName: resultCounty ? `${item.province}-${item.city}-${resultCounty}` : `${item.province}-${item.city}`,
                rateCode: item.locationCode,
                countryCode: item.countryCode
            })
            // uip查询结果和接口返回结构不同，这里需要对省市区三级重新做赋值
            this.updateArea({
                province: {
                    name: item.province,
                    code: item.provinceCode
                },
                city: {
                    name: item.city,
                    code: item.cityCode
                },
                country: {
                    name: item.county,
                    code: item.countyCode
                }
            })
        },
        searchInputBlur() {
            const timerBlur = setTimeout(() => {
                timerBlur && clearTimeout(timerBlur)
                this.selectClass = ''
            }, 500)
        },
        /**
         * 模糊匹配
         */
        async inputChange() {
            if (this.inputTxt) {
                const options = {
                    regionKey: this.regionKey,
                    count: '1000'
                }
                this.searchAddressList = await UIP.interface.region.search(this.inputTxt, options)
                this.searchAddressList.forEach(item => {
                    const str = [item.province, item.city, item.county].filter(item => !!item).join('-')
                    item.html = getHighHtml(str, this.inputTxt)
                    item.cityCode = item.countyAreaCode || ''
                    item.countyCode = item.countyAreaCode || ''
                    item.locationCode = item.countyLocationCode || item.cityLocationCode || item.provinceLocationCode || ''
                    item.provinceCode = item.provinceAreaCode || ''
                    item.countryCode = item.countryCode
                })
            }
        },
        /**
         * 清空搜索数据
         */
        clear() {
            this.selectedItemIndex = -1
            this.searchAddressList = []
            this.inputTxt = ''
        },
        submitSelect() {
            const event = document.createEvent('Events')
            event.initEvent('touchstart', true, true)
            this.$refs.btnConfirm.dispatchEvent(event)
        },
        async validSelector() {
            this.setSelectorValid(true)
            return true
        },
        updateAreaCode({ code, areaName, rateCode, countryCode }) {
            this.addressSelectCommon.code = code
            this.addressSelectCommon.rateCode = rateCode
            this.addressSelectCommon.countryCode = countryCode
            this.addressSelectCommon.areaNameCommon = areaName
        },
        updateCityCode(cityCode) {
            this.addressSelectCommon.cityCode = cityCode
        },
        updateArea(data) {
            this.addressSelectCommon.area = data
        },
        updateSelect(val) {
            this.enableBtn = !!val
        },
        toggleTab(index) {
            if (this.regionTabIndex !== index) {
                this.enableBtn = false
            }
            this.addressSelectCommon.index = index
            this.regionTabIndex = index
            this.selectedItemIndex = -1
        },
        toggleSelector() {
            this.isShowSelector = true
            this.enableBtn = false
            // 查询国际城市（包含港澳台）,组件会对国际城市过滤
            this.getRegion({ code: 'A000000000' }).then(provinces => {
                this.intlProvinces = provinces
            })
        },
        // 查询特殊入仓
        async queryWare() {
            const { city, province, country } = this.addressSelectCommon.area
            const isHK = UIP.utils.check.AREA.isHK(this.addressSelectCommon.rateCode)
            const isHKMOTW = UIP.utils.check.AREA.isHKMOTW(this.addressSelectCommon.rateCode)
            // 港澳台的county和city相同
            const params = {
                province: isHK ? '香港特别行政区' : province.name,
                city: isHK ? '香港特别行政区' : city.name,
                county: isHKMOTW ? city.name : country.name,
                address: this.address
            }
            this.$loading('加载中')
            const {
                data: { result, success, message }
            } = await ajax
                .querySpecialWarehousing({ params })
                .catch(() => {
                    this.$toast('查询异常，请稍后再试')
                })
                .finally(() => {
                    this.$loading()
                })
            if (success) {
                this.resultList = result || []
                if (result.length === 0) {
                    this.$toast('该地址没有特殊入仓服务，暂无收费信息')
                }
            } else {
                this.$toast(message)
            }
        },
        // 点击热门城市
        handledHotCity(val) {
            this.inputTxt = val
            this.inputChange()
        }
    }
}
</script>

<style lang="scss" scoped>
.specialWarehousing-warp {
    background: $gray-lighter;
    position: absolute;
    z-index: 20;
    width: 100%;
    height: 100%;
    bottom: 0;
    overflow: auto;
    .title-wrap {
        background: #fff;
        margin-bottom: 0.2rem;
        padding: 0.2rem;
        color: #151515;
        display: flex;
        align-items: center;
        p {
            position: absolute;
            left: 0.2rem;
            .icon-to-left {
                width: 0.3rem;
            }
        }
        .title {
            width: 100%;
            text-align: center;
            font-size: 0.34rem;
        }
    }
    .content-wrap {
        margin: 0 0.24rem 0.24rem;
        .input-wrap {
            background: #ffffff;
            border-radius: 0.2rem;
            height: 1.2rem;
            display: flex;
            color: #ccc;
            align-items: center;
            justify-content: space-between;
            .input {
                display: flex;
                align-items: center;
                img {
                    width: 0.4rem;
                    height: 0.4rem;
                    margin: 0rem 0.1rem 0 0.4rem;
                }
                .inputValue {
                    color: #0f2124;
                    display: inline-block;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    max-width: 3.8rem;
                }
                .corner {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border: 0.1rem solid black;
                    border-bottom-color: transparent;
                    border-left-color: transparent;
                    border-right-color: transparent;
                    margin-left: 0.1rem;
                    vertical-align: text-top;
                }

                .tip {
                    color: #808080;
                    font-size: 0.26rem;
                    position: absolute;
                    background: #fff;
                    padding: 0;
                    border-radius: 0;
                    line-height: 1;
                    width: auto;
                }
            }
        }
        .hasValueClass {
            height: 1.5rem;
            .input {
                margin-top: -0.3rem;
            }
            .search {
                color: #ff3a3a;
                border-left: 0.03rem solid #f2f3f4;
                padding-left: 0.3rem;
                font-weight: 500;
                line-height: 1;
                margin-right: 0.5rem;
            }
        }
        .result-wrap {
            background: #fff;
            box-shadow: 0 0 0.29rem rgba(0, 0, 0, 0.0388986);
            border-radius: 0.2rem;
            margin-top: 0.24rem;
            padding: 0.3rem;
            h3 {
                color: #0f1214;
                margin-bottom: 0.2rem;
                font-weight: 600;
            }
            .address {
                font-weight: 400;
                font-size: 0.26rem;
                line-height: 0.36rem;
                color: #0f1214;
                margin-bottom: 0.2rem;
            }
            .detail {
                color: #808080;
                font-weight: 400;
                font-size: 0.26rem;
                line-height: 0.5rem;
                vertical-align: middle;
                img {
                    width: 0.34rem;
                    vertical-align: sub;
                }
            }
        }
    }
    .rgn-tab {
        text-align: center;
        li {
            display: inline-block;
            width: 33.3%;
            text-align: center;
            line-height: 2;
            padding: 0.2rem;
        }
        .btn-tab {
            width: 80%;
            margin: 0 auto;
            background: #fff;
            font-size: 0.26rem;
            box-sizing: border-box;
            border: none;
            &.active {
                color: #dc1e32;
                background: #fff;
                &:after {
                    content: '';
                    display: block;
                    position: relative;
                    bottom: 0;
                    left: 20%;
                    width: 60%;
                    height: 0.08rem;
                    background: #fe583c;
                    border-radius: 0.34rem;
                }
            }
        }
    }
    .head {
        padding: 0.3rem;
        font-size: 0.3rem;
        color: #111111;
        font-weight: 800;
    }
    -webkit-overflow-scrolling: touch;
    .hotCity {
        padding: 0.3rem;
        font-size: 0.24rem;
        color: #888888;
    }
    .hotCityList {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        li {
            background: #f5f4f5;
            border-radius: 60px;
            height: 60px;
            width: 20%;
            text-align: center;
            line-height: 0.6rem;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
            &:nth-child(4n + 4) {
                margin-right: 0;
            }
        }
    }
}
.btn-confirm {
    padding: 0.2rem 0.5rem;
    >>> span {
        display: inline-block;
        width: 100%;
        border-radius: 0.48rem;
        text-align: center;
        color: #fff;
        font: bold 0.34rem/3 YaHei;
        letter-spacing: 0.5rem;
        text-indent: 0.5rem;
        background: rgba(0, 0, 0, 0.3);
    }
    &.active {
        >>> span {
            background: #dc1e32;
            color: #ffffff;
        }
    }
}
::-webkit-scrollbar {
    display: none;
}
.search-form {
    position: relative;
    margin: 0.2rem 0.3rem 0;
    width: calc(100% - 0.6rem);
    height: 0.64rem;
    .icon-search {
        position: absolute;
        display: inline-block;
        left: 0.2rem;
        top: 0.18rem;
        width: 0.32rem;
        height: 0.32rem;
        background: url('~@/assets/images/ico/icon-search-gray.png') no-repeat;
        background-size: cover;
    }
    .icon-close {
        position: absolute;
        display: inline-block;
        right: 0.3rem;
        top: 0.18rem;
        width: 0.3rem;
        height: 0.3rem;
        background: url('~@/assets/images/ico/icon-close-new.png') no-repeat;
        background-size: cover;
    }
}
input[type='text'] {
    position: relative;
    padding: 0 0.7rem 0 0.57rem;
    border: none;
    font-size: 0.26rem;
    color: $black;
    background-color: $bg-color;
    border-radius: 0.32rem;
    line-height: 0.64rem;
}
.search-address-region {
    padding-top: 0.32rem;
    max-height: 7rem;
    overflow-y: scroll;
    li {
        width: 100%;
        min-height: 0.96rem;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
        &:nth-child(odd) {
            background-color: #f9f9f9;
        }
        &.active {
            color: rgba(226, 12, 12, 0.842);
            &::before {
                content: '\2714';
                position: relative;
                float: right;
            }
        }
    }
}
</style>

<style lang="scss">
.search-address-region {
    li {
        i {
            display: inline-block;
            color: $red;
            font-style: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/special-warehousing/index.vue